import { MdExpandMore, MdPerson } from 'react-icons/md';
import { useHistory } from 'react-router';
import { Menu } from '@headlessui/react';
import {
  Button,
  DropdownItem,
  DropdownItems,
  Topbar,
  usePopperDropdown,
} from '@nbirl/nbi-common-ui-libs';

import { TopMenu } from '../components';
import { PATHS } from '../constants';
import { useAuth, useCurrentUser } from '../context';

export const AuthenticatedLayout = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const history = useHistory();
  const { signOut } = useAuth();
  const { name } = useCurrentUser();
  const { referenceElementProps, popperElementProps } = usePopperDropdown({
    sameWidth: true,
    placement: 'bottom-start',
  });

  return (
    <div className="h-full w-full flex flex-col overflow-hidden">
      <Topbar className="z-20 h-20 flex-shrink-0 w-full">
        <TopMenu className="flex-1 ml-20" />
        <div className="relative">
          <Menu>
            {({ open }) => (
              <>
                <Menu.Button
                  as={Button}
                  variant="ghost"
                  leftIcon={<MdPerson />}
                  rightIcon={<MdExpandMore className="w-6 h-6" />}
                  active={open}
                  {...referenceElementProps}
                >
                  {name}
                </Menu.Button>
                <DropdownItems {...popperElementProps}>
                  <DropdownItem
                    onClick={() => history.push(PATHS.ChangePassword)}
                  >
                    Change password
                  </DropdownItem>
                  <DropdownItem onClick={() => signOut()}>Logout</DropdownItem>
                </DropdownItems>
              </>
            )}
          </Menu>
        </div>
      </Topbar>

      {children}
    </div>
  );
};
